import { Chip, Tooltip } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

export const InternalOnlyBadge = () => (
  <Tooltip title="Physna internal only. Customers don't see this." placement='top'>
    <Chip
      icon={<LockOutlinedIcon sx={{ fontSize: '12px !important' }} />}
      label='Physna internal'
      size='small'
      color='warning'
      variant='outlined'
      sx={{ height: 20, fontSize: '0.6rem', px: 0.15 }}
    />
  </Tooltip>
);
